export function createDocumentInputUploadedFileName(sectionKey, sectionFileKey) {
  return `${sectionKey}|${sectionFileKey}`;
}
